<ng-template #templateRef>
	<div
		class="loading-container vw-100 vh-100 justify-content-{{
			horizontal()
		}} align-items-{{ vertical() }}"
		[class.backdrop]="backdrop()"
		[style.backgroundColor]="
			backdrop() ? backdropBackgroundColor() : 'transparent'
		"
		[style.opacity]="opacity()"
	>
		<div
			class="loading-content pr-4 pb-4"
			[style.width]="size()[0]"
			[style.height]="size()[1]"
		>
			<ng-content></ng-content>
		</div>
	</div>
</ng-template>
